module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/7qKxcW/tc-custom/9781446357729.jpg?1718251155008",
      "alt": "This image is the cover for the book Fifty Years of Psychical Research, The Paranormal"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Fifty Years of Psychical Research, The Paranormal\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An in-depth history of psychical research and spiritualism, accompanied by period illustrations.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Is spiritualism a religion or a racket? How does it differ from psychical research? What went on in the world of séances, mediums, and the scientists who investigated them in the early decades of the twentieth century? This fascinating account, first published in the 1930s, brings to life an era when spiritualists gripped the public imagination and researchers fought to determine what was and wasn’t real."), _c('br'), _vm._v(" "), _c('br'), _c('i', [_vm._v("Fifty Years of Psychical Research")]), _vm._v(" is part of The Paranormal, a series that resurrects rare titles, classic publications, and out-of-print texts, as well as publishes new supernatural and otherworldly ebooks for the digital age. The series includes a range of paranormal subjects from angels, fairies, and UFOs to near-death experiences, vampires, ghosts, and witchcraft.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Harry Price\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    F+W Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0